var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-post"},[_c('v-text-field',{staticClass:"style-input sm3",attrs:{"label":_vm.filters.label,"outline":"","height":"30","type":"text"},on:{"change":_vm.triggerEvent},model:{value:(_vm.filters.default),callback:function ($$v) {_vm.$set(_vm.filters, "default", $$v)},expression:"filters.default"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }